package com.neurobs.js.ccab

import com.neurobs.ccab.ObjectResult
import com.neurobs.js.http

object ResponseHandlers {

  def handleObjectResultResponse[T](handleObject: T => Unit, handleObjectError: String => Unit, handleServerError: String => Unit): http.ServerObjectResponse[ObjectResult[T]] => Unit = {
    (res: http.ServerObjectResponse[ObjectResult[T]]) => res match {
      case Left(serverError) => handleServerError(serverError.message)
      case Right(result: ObjectResult[T]) => result.error match {
        case Some(objectError) => handleObjectError(objectError)
        case None => result.data match {
          case Some(obj) => handleObject(obj)
          case None => handleObjectError("Object data and error should not both be None")
        }
      }
    }
  }

  def handleObjectResponse[T](handleObject: T => Unit, handleServerError: String => Unit): http.ServerObjectResponse[T] => Unit = {
    (res: http.ServerObjectResponse[T]) => res match {
      case Left(serverError) => handleServerError(serverError.message)
      case Right(data) => handleObject(data)
    }
  }

}
